import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["defaultOpen"],
  _excluded2 = ["id"],
  _excluded3 = ["id"];
var _Y;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import E, { createContext as I, Fragment as H, useContext as x, useEffect as h, useMemo as S, useReducer as G, useRef as R } from "react";
import { useEvent as A } from '../../hooks/use-event.js';
import { useId as U } from '../../hooks/use-id.js';
import { useResolveButtonType as j } from '../../hooks/use-resolve-button-type.js';
import { optionalRef as W, useSyncRefs as L } from '../../hooks/use-sync-refs.js';
import { OpenClosedProvider as $, State as b, useOpenClosed as J } from '../../internal/open-closed.js';
import { isDisabledReactIssue7711 as X } from '../../utils/bugs.js';
import { match as O } from '../../utils/match.js';
import { getOwnerDocument as q } from '../../utils/owner.js';
import { Features as w, forwardRefWithAs as B, render as k, useMergeRefsFn as N } from '../../utils/render.js';
import { startTransition as z } from '../../utils/start-transition.js';
import { Keys as g } from '../keyboard.js';
var Q = function (o) {
    return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
  }(Q || {}),
  V = function (t) {
    return t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t;
  }(V || {});
var Y = (_Y = {}, _defineProperty(_Y, 0, function _(e) {
    var _O;
    return _objectSpread(_objectSpread({}, e), {}, {
      disclosureState: O(e.disclosureState, (_O = {}, _defineProperty(_O, 0, 1), _defineProperty(_O, 1, 0), _O))
    });
  }), _defineProperty(_Y, 1, function _(e) {
    return e.disclosureState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
      disclosureState: 1
    });
  }), _defineProperty(_Y, 4, function _(e) {
    return e.linkedPanel === !0 ? e : _objectSpread(_objectSpread({}, e), {}, {
      linkedPanel: !0
    });
  }), _defineProperty(_Y, 5, function _(e) {
    return e.linkedPanel === !1 ? e : _objectSpread(_objectSpread({}, e), {}, {
      linkedPanel: !1
    });
  }), _defineProperty(_Y, 2, function _(e, n) {
    return e.buttonId === n.buttonId ? e : _objectSpread(_objectSpread({}, e), {}, {
      buttonId: n.buttonId
    });
  }), _defineProperty(_Y, 3, function _(e, n) {
    return e.panelId === n.panelId ? e : _objectSpread(_objectSpread({}, e), {}, {
      panelId: n.panelId
    });
  }), _Y),
  M = I(null);
M.displayName = "DisclosureContext";
function _(e) {
  var n = x(M);
  if (n === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, _), o;
  }
  return n;
}
var v = I(null);
v.displayName = "DisclosureAPIContext";
function K(e) {
  var n = x(v);
  if (n === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, K), o;
  }
  return n;
}
var F = I(null);
F.displayName = "DisclosurePanelContext";
function Z() {
  return x(F);
}
function ee(e, n) {
  return O(n.type, Y, e, n);
}
var te = H;
function ne(e, n) {
  var _O2;
  var _e$defaultOpen = e.defaultOpen,
    o = _e$defaultOpen === void 0 ? !1 : _e$defaultOpen,
    i = _objectWithoutProperties(e, _excluded),
    f = R(null),
    l = L(n, W(function (u) {
      f.current = u;
    }, e.as === void 0 || e.as === H)),
    t = R(null),
    d = R(null),
    s = G(ee, {
      disclosureState: o ? 0 : 1,
      linkedPanel: !1,
      buttonRef: d,
      panelRef: t,
      buttonId: null,
      panelId: null
    }),
    _s = _slicedToArray(s, 2),
    _s$ = _s[0],
    c = _s$.disclosureState,
    a = _s$.buttonId,
    D = _s[1],
    p = A(function (u) {
      D({
        type: 1
      });
      var y = q(f);
      if (!y || !a) return;
      var r = function () {
        return u ? u instanceof HTMLElement ? u : u.current instanceof HTMLElement ? u.current : y.getElementById(a) : y.getElementById(a);
      }();
      r == null || r.focus();
    }),
    P = S(function () {
      return {
        close: p
      };
    }, [p]),
    T = S(function () {
      return {
        open: c === 0,
        close: p
      };
    }, [c, p]),
    C = {
      ref: l
    };
  return E.createElement(M.Provider, {
    value: s
  }, E.createElement(v.Provider, {
    value: P
  }, E.createElement($, {
    value: O(c, (_O2 = {}, _defineProperty(_O2, 0, b.Open), _defineProperty(_O2, 1, b.Closed), _O2))
  }, k({
    ourProps: C,
    theirProps: i,
    slot: T,
    defaultTag: te,
    name: "Disclosure"
  }))));
}
var le = "button";
function oe(e, n) {
  var o = U(),
    _e$id = e.id,
    i = _e$id === void 0 ? "headlessui-disclosure-button-".concat(o) : _e$id,
    f = _objectWithoutProperties(e, _excluded2),
    _ref = _("Disclosure.Button"),
    _ref2 = _slicedToArray(_ref, 2),
    l = _ref2[0],
    t = _ref2[1],
    d = Z(),
    s = d === null ? !1 : d === l.panelId,
    c = R(null),
    a = L(c, n, s ? null : l.buttonRef),
    D = N();
  h(function () {
    if (!s) return t({
      type: 2,
      buttonId: i
    }), function () {
      t({
        type: 2,
        buttonId: null
      });
    };
  }, [i, t, s]);
  var p = A(function (r) {
      var m;
      if (s) {
        if (l.disclosureState === 1) return;
        switch (r.key) {
          case g.Space:
          case g.Enter:
            r.preventDefault(), r.stopPropagation(), t({
              type: 0
            }), (m = l.buttonRef.current) == null || m.focus();
            break;
        }
      } else switch (r.key) {
        case g.Space:
        case g.Enter:
          r.preventDefault(), r.stopPropagation(), t({
            type: 0
          });
          break;
      }
    }),
    P = A(function (r) {
      switch (r.key) {
        case g.Space:
          r.preventDefault();
          break;
      }
    }),
    T = A(function (r) {
      var m;
      X(r.currentTarget) || e.disabled || (s ? (t({
        type: 0
      }), (m = l.buttonRef.current) == null || m.focus()) : t({
        type: 0
      }));
    }),
    C = S(function () {
      return {
        open: l.disclosureState === 0
      };
    }, [l]),
    u = j(e, c),
    y = s ? {
      ref: a,
      type: u,
      onKeyDown: p,
      onClick: T
    } : {
      ref: a,
      id: i,
      type: u,
      "aria-expanded": l.disclosureState === 0,
      "aria-controls": l.linkedPanel ? l.panelId : void 0,
      onKeyDown: p,
      onKeyUp: P,
      onClick: T
    };
  return k({
    mergeRefs: D,
    ourProps: y,
    theirProps: f,
    slot: C,
    defaultTag: le,
    name: "Disclosure.Button"
  });
}
var re = "div",
  se = w.RenderStrategy | w.Static;
function ue(e, n) {
  var o = U(),
    _e$id2 = e.id,
    i = _e$id2 === void 0 ? "headlessui-disclosure-panel-".concat(o) : _e$id2,
    f = _objectWithoutProperties(e, _excluded3),
    _ref3 = _("Disclosure.Panel"),
    _ref4 = _slicedToArray(_ref3, 2),
    l = _ref4[0],
    t = _ref4[1],
    _K = K("Disclosure.Panel"),
    d = _K.close,
    s = N(),
    c = L(n, l.panelRef, function (T) {
      z(function () {
        return t({
          type: T ? 4 : 5
        });
      });
    });
  h(function () {
    return t({
      type: 3,
      panelId: i
    }), function () {
      t({
        type: 3,
        panelId: null
      });
    };
  }, [i, t]);
  var a = J(),
    D = function () {
      return a !== null ? (a & b.Open) === b.Open : l.disclosureState === 0;
    }(),
    p = S(function () {
      return {
        open: l.disclosureState === 0,
        close: d
      };
    }, [l, d]),
    P = {
      ref: c,
      id: i
    };
  return E.createElement(F.Provider, {
    value: l.panelId
  }, k({
    mergeRefs: s,
    ourProps: P,
    theirProps: f,
    slot: p,
    defaultTag: re,
    features: se,
    visible: D,
    name: "Disclosure.Panel"
  }));
}
var ie = B(ne),
  ae = B(oe),
  pe = B(ue),
  Ae = Object.assign(ie, {
    Button: ae,
    Panel: pe
  });
export { Ae as Disclosure };